import { calculateMultiSlotAvailability as universalCalculateMultiSlotAvailability, getScheduleAvailability as universalGetScheduleAvailability, queryAvailability as universalQueryAvailability, } from './bookings-availability-v1-slot-availability-availability-calendar.universal';
export const __metadata = { PACKAGE_NAME: '@wix/bookings' };
export function queryAvailability(httpClient) {
    return (query, options) => universalQueryAvailability(query, options, 
    // @ts-ignore
    { httpClient });
}
export function getScheduleAvailability(httpClient) {
    return (scheduleId) => universalGetScheduleAvailability(scheduleId, 
    // @ts-ignore
    { httpClient });
}
export function calculateMultiSlotAvailability(httpClient) {
    return (options) => universalCalculateMultiSlotAvailability(options, 
    // @ts-ignore
    { httpClient });
}
export { LocationLocationType, LocationType, SortOrder, } from './bookings-availability-v1-slot-availability-availability-calendar.universal';
//# sourceMappingURL=bookings-availability-v1-slot-availability-availability-calendar.public.js.map